import {Checkbox} from "@blueprintjs/core";

export default Checkbox;